import useClassifySetting from './use_classify_setting';

export default function useIsNPS() {
  const classifySetting = useClassifySetting();
  return classifySetting === 'NPS';
}

